import { loadIntercom } from '@/utils/intercom'

export const intercomMethods = {
    methods: {
        withIntercomLauncherHidden(payload = {}) {
            return {
                ...payload,
                hide_default_launcher: true
            }
        },
        updateIntercom(intercom, payload = {}) {
            intercom?.('update', this.withIntercomLauncherHidden(payload))
        },
        ensureIntercomReady(preBoot) {
            const appId = this.$appConfig?.VUE_APP_INTERCOM_ID
            const intercom = loadIntercom(appId)
            if (!intercom) return null

            const user = preBoot || this.userInfo || this.$store?.state?.userInfo
            const hasBootConfig = Boolean(window.intercomSettings?.app_id)

            if (!hasBootConfig && appId) {
                const bootSettings = {
                    app_id: appId
                }

                if (user?.hmac) {
                    bootSettings.email = user.email
                    bootSettings.user_id = user.uid
                    bootSettings.user_hash = user.hmac
                    bootSettings.name = user.name || user.given_name + ' ' + user.family_name
                    bootSettings.is_trial_user = user.is_trial_user
                }

                window.intercomSettings = this.withIntercomLauncherHidden(bootSettings)
                intercom('boot', window.intercomSettings)
            } else {
                this.updateIntercom(intercom)
            }

            return intercom
        },
        showIntercomChat() {
            const intercom = this.ensureIntercomReady()
            this.updateIntercom(intercom)
            intercom?.('show')
            intercom?.('showMessages')
        },
        showNewMessageIntercom(msg, preBoot) {
            const intercom = this.ensureIntercomReady(preBoot)
            this.updateIntercom(intercom)
            intercom?.('show')
            intercom?.('showNewMessage', msg)
        }
    }
}
